import {WealthyEnv} from "helpers";
import axios from "axios";

const firstEntryOnThePage = function () {
  if (!sessionStorage.isFirstEntry) {
    setTimeout(function () {
      window?.analytics.identify(), 100;
    });
    sessionStorage.isFirstEntry = true;
  }
};

const getCookie = function () {
  const regex = /rsessionid=([^;]+)/;
  const match = regex.exec(document.cookie);
  if (match) {
    return match[1];
  }
  return "ressionid not present in cookies";
};

export const trackEvents = function (message, metaData, ignorePageCallForClickables) {
  firstEntryOnThePage();
  const id = getCookie();
  if (!metaData) {
    metaData = {};
  }
  metaData.rsessionid = id;
  if (!ignorePageCallForClickables) {
    window?.analytics.page();
  }
  window?.analytics.track(message, metaData);
};

export const shareContent = function (socialPlatform) {
  const ignorePageCallEventForClickables = true;
  const apiUrl = `${WealthyEnv.GATE_WEALTHY_API_URL}/share/?object_id=${this.props.id}&content_type_id=${this.props.contentTypeId}&social_platform=${socialPlatform}&page_url=${window.location}`;
  axios.get(apiUrl)
    .then(() => {
    })
    .catch(() => {
    });

  trackEvents("Shared Insights Content", {platform: socialPlatform, content_type: this.props.contentTypeName, content_title: this.props.contentTitle}, ignorePageCallEventForClickables);

  if (socialPlatform === "facebook") {
    const fbAppId = '512131318964408';
    window.open(`https://www.facebook.com/dialog/share?app_id=${fbAppId}&href=${window.location}`);
  }

  if (socialPlatform === "twitter") {
    window.open("https://www.twitter.com/share?url=\" + window.location + \"&amp;related=roadtowealthy&amp;via=roadtowealthy");
  }
  if (socialPlatform === "whatsapp") {
    window.open(`whatsapp://send?text=${window.location}`);
  }
};


export const isMobile = () => {
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
};


